import React, { useState, useEffect } from 'react';
import './ThemeToggle.css';

const SunIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="4"/>
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/>
  </svg>
);

const MoonIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
  </svg>
);

const ThemeToggle = ({ theme, toggleTheme }) => {
  const [spinning, setSpinning] = useState(false);

  const handleClick = () => {
    setSpinning(true);
    toggleTheme();
  };

  useEffect(() => {
    if (!spinning) return;
    const timer = setTimeout(() => setSpinning(false), 400);
    return () => clearTimeout(timer);
  }, [spinning]);

  return (
    <button
      onClick={handleClick}
      className="theme-toggle"
      aria-label="Toggle theme"
    >
      <span className={`icon-sun${spinning ? ' spinning' : ''}`}><SunIcon /></span>
      <span className={`icon-moon${spinning ? ' spinning' : ''}`}><MoonIcon /></span>
      <span className="theme-toggle-label">{theme === 'dark' ? 'Dark' : 'Light'}</span>
    </button>
  );
};

export default ThemeToggle;
